'use client';
import React, { useMemo, useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import useContainerOffset from '@/src/hooks/useContainerOffset.jsx';
import useDeviceTypeMobile from '@/src/hooks/useDeviceTypeMobile.jsx';
import Title from '@/src/components/common/ui/text/Title.jsx';
import SolutionSingle from '@/src/components/common/ui/single-item/SolutionSingle.jsx';
import { gsap } from 'gsap';
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { StyledIndustryContainer } from '@/src/components/common/eco/sections/service-list/service.style.js';
import useLineDrawAnimation from '@/src/hooks/useLineDrawAnimation.jsx';
import Accordion from 'react-bootstrap/Accordion';
import reactHtmlParser from 'react-html-parser';
if (typeof window !== 'undefined') {
	gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);
}
const Industry = ({data}) => {
	const isMobile = useDeviceTypeMobile();
	const offset = useContainerOffset('.container');
	useLineDrawAnimation('.line-draw')

	const itemRefs = useRef({});

	// Scroll handler: scroll clicked item to top of viewport
	const handleSelect = (eventKey) => {
		const el = itemRefs.current[eventKey];
		if (el) {
			// Scroll so top of element is at viewport top
			// You can tweak behavior (smooth or instant)
			const headerHeight = 60; // example fixed header height in px
			const scrollTop = document.querySelector('.accordion').getBoundingClientRect().top + window.pageYOffset - headerHeight;
			const maxScrollTop = document.documentElement.scrollHeight - window.innerHeight;

			const finalScrollTop = Math.min(scrollTop, maxScrollTop);

			window.scrollTo({
				top: scrollTop - 80,
				behavior: 'smooth',
			});

			ScrollTrigger.refresh()
		}
	};

	// Memoize the renderMobileService function to prevent unnecessary re-renders
	const renderServiceMobile = useMemo(() =>
			// eslint-disable-next-line react/display-name
			(subItem, subIndex) => {
				return(
					<Accordion.Item eventKey={subIndex}  key={subIndex} className={`event-${subIndex}`}  ref={(el) => (itemRefs.current[subIndex] = el)}>
						<Accordion.Header>
							<span>{reactHtmlParser(subItem?.data?.title)}</span>
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M6.25 1C6.25 0.801088 6.32902 0.610322 6.46967 0.46967C6.61032 0.329018 6.80109 0.25 7 0.25C7.19891 0.25 7.38968 0.329018 7.53033 0.46967C7.67098 0.610322 7.75 0.801088 7.75 1V6.25H13C13.1989 6.25 13.3897 6.32902 13.5303 6.46967C13.671 6.61032 13.75 6.80109 13.75 7C13.75 7.19891 13.671 7.38968 13.5303 7.53033C13.3897 7.67098 13.1989 7.75 13 7.75H7.75V13C7.75 13.1989 7.67098 13.3897 7.53033 13.5303C7.38968 13.671 7.19891 13.75 7 13.75C6.80109 13.75 6.61032 13.671 6.46967 13.5303C6.32902 13.3897 6.25 13.1989 6.25 13V7.75H1C0.801088 7.75 0.610322 7.67098 0.46967 7.53033C0.329018 7.38968 0.25 7.19891 0.25 7C0.25 6.80109 0.329018 6.61032 0.46967 6.46967C0.610322 6.32902 0.801088 6.25 1 6.25H6.25V1Z" fill="white" />
							</svg>
							<svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M0.25 1C0.25 0.801088 0.329018 0.610323 0.46967 0.46967C0.610322 0.329018 0.801088 0.25 1 0.25H13C13.1989 0.25 13.3897 0.329018 13.5303 0.46967C13.671 0.610323 13.75 0.801088 13.75 1C13.75 1.19891 13.671 1.38968 13.5303 1.53033C13.3897 1.67098 13.1989 1.75 13 1.75H1C0.801088 1.75 0.610322 1.67098 0.46967 1.53033C0.329018 1.38968 0.25 1.19891 0.25 1Z" fill="white" />
							</svg>
						</Accordion.Header>
						<Accordion.Body>
							<SolutionSingle accordion description={subItem?.data?.description} img={subItem?.images?.[0]?.full_path}/>
						</Accordion.Body>
					</Accordion.Item>

				)
			},
		[],
	);
	// Memoize the renderDesktopService function to prevent unnecessary re-renders
	const renderServiceDeskTop = useMemo(() =>
			// eslint-disable-next-line react/display-name
			(subItem, subIndex, isLast) => {
				const isLastItem = subIndex === isLast - 1;
				if(!isLastItem){
					return(
						<Col md={4} key={subIndex}>
							<SolutionSingle title={subItem?.data?.title} description={subItem?.data?.description} img={subItem?.images?.[0]?.full_path}/>
						</Col>
					)
				}else{
					return(
						<Col md={12} key={subIndex} className={'solution-last'}>
							<svg width="1170" height="74" viewBox="0 0 1170 74" fill="none" className={'line-draw'} xmlns="http://www.w3.org/2000/svg">
								<line x1="0.5" y1="1.73708e-08" x2="0.499999" y2="27" stroke="white" />
								<line x1="1169.5" y1="1.73708e-08" x2="1169.5" y2="27" stroke="white" />
								<line x1="5.52349e-08" y1="26.5" x2="1169" y2="26.5001" stroke="white" />
								<line x1="585.5" y1="27" x2="585.5" y2="74" stroke="white" />
							</svg>

							<SolutionSingle version title={subItem?.data?.title} description={subItem?.data?.description} img={subItem?.images?.[0]?.full_path} />
						</Col>
					)
				}
			},
		[],
	);


	return (
		<StyledIndustryContainer  id={'services'} offset={offset} className={`main-services-list`}>
			<Container>

				{
					data?.section_data?.subtitle &&
					<Row>
						<Col md={12}>
							<Title
								tag={'h2'}
								margin={'0 0 60px'}
								text={data?.section_data?.subtitle}
								color={'#fff'}
							/>
						</Col>
					</Row>


				}
				{
					isMobile &&
					<Accordion onSelect={handleSelect}>
						{
							data?.posts?.list && data?.posts?.list?.length > 0 &&
							data?.posts?.list?.map((subItem, subIndex) => renderServiceMobile(subItem, subIndex))
						}
					</Accordion>
				}


				{
					!isMobile &&
					<Row className={'services-list'}>
						{
							data?.posts?.list && data?.posts?.list?.length > 0 &&
							data?.posts?.list?.map((subItem, subIndex) => renderServiceDeskTop(subItem, subIndex, data?.posts?.list?.length))
						}
					</Row>
				}

			</Container>
		</StyledIndustryContainer>
	);
};


export default React.memo(Industry);
